import type { FC } from 'react';

import Dota2Players from './Dota2Players';
import LolPlayers from './LolPlayers';
import PlayersTable from './PlayersTable';

interface Props {
  data: PlayersStatsBlockMatch;
}

const PlayersStatsBlock: FC<Props> = ({ data }) => {
  switch (data.videogame_slug) {
    case 'dota-2':
      return <Dota2Players data={data} />;
    case 'league-of-legends':
      return <LolPlayers data={data} />;
    default:
      return <PlayersTable data={data} />;
  }
};

PlayersStatsBlock.displayName = 'PlayersStatsBlock';

export default PlayersStatsBlock;
